import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { pairwise } from 'rxjs/operators';
import { CustomProductsService } from '../custom-products.service';
import { Port } from '../../../../core/model/port-model';
import { ChangeDetectorRef } from '@angular/core';
import { TranslationService, I18nModule } from '@spartacus/core';
import { NgIf, NgFor } from '@angular/common';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CustomProductCarouselComponent } from '../custom-product-carousel/custom-product-carousel.component';
import { ProductsListViewComponent } from '../products-list-view/products-list-view.component';
@Component({
    selector: 'app-custom-ports-content',
    templateUrl: './custom-ports-content.component.html',
    styleUrls: ['./custom-ports-content.component.scss'],
    imports: [NgIf, InfiniteScrollDirective, NgFor, CustomProductCarouselComponent, ProductsListViewComponent, I18nModule]
})
export class CustomPortsContentComponent implements OnInit {
   browseType = 'port';
   @Input() list: any;
   portsList: Port[] = [];
   @Input() grid: any;
   @Input() sortData: any;
   loaderShow = false;
   sampleData = {};
   showNotAvailableMsg = false;
   enableLoader = true;
   page = 0;
   nextProducts: any;
   currentPage = 0;
   pageSize = 2;
   reachedToEnd = false;
   filterUrl = null;
  error: string;
   constructor(private customProductService: CustomProductsService,
               private toastService: ToastrService, private cd: ChangeDetectorRef, private translation: TranslationService) {
   }

   ngOnInit(): void {
      this.browseByPort(this.currentPage, this.pageSize, this.sortData, this.customProductService.filterValue);

      this.customProductService.filterInput$.pipe(pairwise()).subscribe(([previous, current]) => {
         if (previous !== current) {
         this.cd.detectChanges();
         this.enableLoader = true;
         this.reachedToEnd = false;
         this.currentPage = 0;
         this.pageSize = 2;
         this.page = 0;
         this.filterUrl = current;
         if (this.filterUrl != null){
           this.browseByPort(0 , this.pageSize, 'relevance' , current);
         }else{
           this.browseByPort(0, this.pageSize, this.sortData);
         }
       }
       });

      this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
         if (previous !== current) {
            if (current != null) {
               this.enableLoader = true;
               this.browseByPort(this.currentPage, this.pageSize, this.sortData, this.customProductService.filterValue);
            }
         }
      });
      this.customProductService.searchInput$.pipe(pairwise()).subscribe(([previous, current]) => {
         if (previous !== current) {
         this.cd.detectChanges();
         this.reachedToEnd = false;
         this.currentPage = 0;
         this.page = 0;
         this.browseByPort(this.currentPage, this.pageSize, 'relevance' , current);
         }
       });
      this.customProductService.refreshComp$.pipe(pairwise()).subscribe(([previous, current]) => {
         if (current != null && current) {
            this.enableLoader = true;
            this.browseByPort(this.currentPage, this.pageSize, this.sortData, this.customProductService.filterValue);
         }
      });
      this.translation.translate('home.toastErrorMessages.port').subscribe(res => {

        this.error = res;
      });

   }

   browseByPort(currentPage?, pageSize?, sort? , searchInput?): any {
      this.showNotAvailableMsg = false;
      this.customProductService.getBrowseByPortsData(currentPage, pageSize, sort , searchInput)
         .subscribe((data) => {
            this.showNotAvailableMsg = false;
            if (data.ports !== undefined) {
               if (data.ports.length !== 0){
                  this.portsList = data.ports;
                  this.enableLoader = false;
               }else{
                  this.enableLoader = false;
                  this.showNotAvailableMsg = true;
               }

            }else{
               this.enableLoader = false;
               this.showNotAvailableMsg = true;
            }
         },
            err => {
               this.toastService.show(this.error);
               this.enableLoader = false;
            });
   }

  onScrollGrid(): any {
    if (!this.reachedToEnd){
    this.loaderShow = true;
    setTimeout(() => {
      this.loadNextDataProductsGrid();
    }, 1000);
    }
  }

  loadNextDataProductsGrid(): any {
    this.page += 1;
    if (!this.reachedToEnd){
      this.customProductService.getBrowseByPortsData(this.page, this.pageSize, this.sortData, this.customProductService.filterValue)
      .subscribe(data => {
        this.loaderShow = false;
        this.nextProducts = data;
        if (data.pagination.totalResults === 0) {
          this.reachedToEnd = true;
        }
        if(this.nextProducts.ports){
        this.portsList = this.portsList.concat(this.nextProducts.ports);
        }
      });
    }else{
      this.loaderShow = false;
    }
  }

  onScroll(): any {
    if (!this.reachedToEnd){
    this.loaderShow = true;
    setTimeout(() => {
      this.loadNextDataProducts();
    }, 1000);
      }
  }

  loadNextDataProducts(): any {
    this.currentPage += 1;
    if (!this.reachedToEnd){
      this.customProductService.getBrowseByPortsData(this.currentPage, this.pageSize, this.sortData, this.customProductService.filterValue)
      .subscribe(data => {
        this.loaderShow = false;
        this.nextProducts = data;
        if (this.nextProducts.pagination.totalResults === 0) {
          this.reachedToEnd = true;
        }
        if(this.nextProducts.ports){
        this.portsList = this.portsList.concat(this.nextProducts.ports);
        }

      });
    }else{
      this.loaderShow = false;
    }
    // this.productData.products = this.productData.products.concat(this.nextProducts.products);
  }

}
